import { Group } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { EditorChipButton } from './EditorChipButton';

type FilterDropdownActionsProps = {
  accentColor?: string;
  onReset: () => void;
};

/** Footer action for filter menus — clear selection (apply is immediate on checkbox click). */
export function FilterDropdownActions({ accentColor, onReset }: FilterDropdownActionsProps) {
  const { t } = useTranslation();

  return (
    <Group p="sm" justify="flex-end" gap="xs">
      <EditorChipButton accentColor={accentColor} onClick={onReset}>
        {t('marketplace.search.reset')}
      </EditorChipButton>
    </Group>
  );
}
